
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useTranslation } from 'react-i18next';
import { languages, timezones } from '@/utils/profile-options';

interface PreferencesFormProps {
  timezone?: string | null;
  preferredLanguage: string;
  onTimezoneChange: (value: string) => void;
  onPreferredLanguageChange: (value: string) => void;
  isSubmitting?: boolean;
}

const PreferencesForm: React.FC<PreferencesFormProps> = ({ 
  timezone,
  preferredLanguage,
  onTimezoneChange,
  onPreferredLanguageChange,
  isSubmitting = false
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="space-y-6">
      <div id="client-timezone-field" data-tour="client-timezone">
        <Label htmlFor="timezone">{t('preferences.timezone')}</Label>
        <Select
          name="timezone"
          value={timezone || undefined}
          onValueChange={onTimezoneChange}
          disabled={isSubmitting}
        >
          <SelectTrigger>
            <SelectValue placeholder={t('preferences.selectTimezone')} />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {timezones.map((timezone) => (
              <SelectItem key={timezone.value} value={timezone.value}>
                {timezone.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground mt-1">
          {t('preferences.timezoneNote')}
        </p>
        {!timezone && (
          <p className="text-xs text-amber-700 mt-1">
            Please select your timezone and save to avoid appointment time mistakes.
          </p>
        )}
      </div>
      
      <div>
        <Label htmlFor="preferred_language">{t('preferences.preferredLanguage')}</Label>
        <Select
          name="preferred_language"
          value={preferredLanguage || "en"}
          onValueChange={onPreferredLanguageChange}
          disabled={isSubmitting}
        >
          <SelectTrigger>
            <SelectValue placeholder={t('preferences.selectLanguage')} />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {languages.map((language) => (
              <SelectItem key={language.value} value={language.value}>
                {language.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default PreferencesForm;
